// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"175":"4b68e092b0bdd3ad","681":"b4e4bd88f4749ec1","930":"ddf44295894f5943"}[chunkId] + ".js";
};